let hour = ['']
for (let i = 0; i < 24; i++) {
  if (i < 10) {
    i = '0' + i
  }
  hour.push(i.toString())
}
let minute = ['']
for (let i = 0; i < 60; i++) {
  if (i < 10) {
    i = '0' + i
  }
  minute.push(i.toString())
}
let adjustMinute = ['']
for (let i = 0; i < 6; i++) {
  if (i === 0) {
    adjustMinute.push('00')
  } else {
    adjustMinute.push(i + '0')
  }
}
let time = {
  'hour': hour,
  'minute': minute,
  'adjustMinute': adjustMinute
}
export default time



// WEBPACK FOOTER //
// ./src/assets/js/time.js